import { actions } from './slice';
import {
  getCaregiverPatientsData,
  deletePatientAndCaregiverConnectionByEmail,
  connectPatientAndCaregiverConnectionByEmail,
  getPatientsByFacilityId,
} from './actions';

const allActions = {
  ...actions,
  getCaregiverPatientsData,
  deletePatientAndCaregiverConnectionByEmail,
  connectPatientAndCaregiverConnectionByEmail,
  getPatientsByFacilityId,
};

export { allActions as patientsActions };
export { reducer as patientsReducer } from './slice';
